module.exports = __webpack_public_path__ + "static/media/tif.f5bc9534.svg";